<template>
    <div class="notificar-usuarios-container">
      <CardPrime class="notificar-usuarios-card">
        <template #title>
          <div class="card-header">
            <h3 class="card-title">Notificar Usuarios</h3>
          </div>
        </template>
        <template #content>
          <div class="form-field">
            <label for="colegio-select">Seleccionar Colegio:</label>
            <ColegioDropdown 
              v-model="selectedColegio" 
              @change="cargarCursos" 
              :mostrarErrores="false" 
              :tooltip="''" 
              :error="''"
            />
          </div>
  
          <div class="form-field">
            <label for="curso-select">Seleccionar Curso:</label>
            <SingleCursoCombo 
              :mostrarErrores="true" 
              :tooltip="'Selecciona un Curso'" 
              :error="errors.cursos" 
              :modelValue="selectedCurso" 
              @update:modelValue="selectedCurso = $event" 
            />
            <small v-if="mostrarErrores && errors.cursos" class="p-error">{{ errors.cursos }}</small>
          </div>
  
          <ButtonPrime label="Buscar Usuarios" @click="buscarUsuarios" />
  
          <div v-if="usuarios.length > 0">
            <h4>Resultados:</h4>
            <DataTable 
              :value="usuarios" 
              class="p-datatable-sm" 
              selection-mode="multiple" 
              v-model:selection="selectedUsuarios" 
              dataKey="id_usuario" 
            >
              <ColumnPrime selectionMode="multiple" headerStyle="width: 3em" />
              <ColumnPrime field="nombre" header="Nombre" />
              <ColumnPrime field="email" header="Email" />
              <ColumnPrime field="curso" header="Curso" />
              <ColumnPrime field="colegio" header="Colegio" />
              <ColumnPrime header="Acciones">
                <template #body="slotProps">
                  <ButtonPrime 
                    icon="pi pi-envelope" 
                    class="p-button-rounded p-button-success p-button-sm p-mr-2" 
                    @click="openEmailModal(slotProps.data)" 
                  />
                  <ButtonPrime 
                    icon="pi pi-bell" 
                    class="p-button-rounded p-button-warning p-button-sm" 
                    @click="openPushModal(slotProps.data)" 
                  />
                </template>
              </ColumnPrime>
            </DataTable>
          </div>
  
          <ButtonPrime label="Notificar EMAIL Seleccionados" @click="openEmailModalSelect" v-if="selectedUsuarios.length > 0" />
            <ButtonPrime label="Notificar PUSH Seleccionados" @click="openPushModalSelect" v-if="selectedUsuarios.length > 0" />
        </template>
      </CardPrime>
  
      <!-- Modal para opciones de notificación -->
      <DialogPrime header="Opciones de Notificación" v-model:visible="showEmailModal" :modal="true" :closable="false">
        <div>
          <p>Selecciona la opción de Email:</p>
          <div>
            <label>
              <input type="radio" v-model="selectedNotificationOption" value="Estadisticas Alumnos Opción A" />
              Estadísticas Alumnos Opción A
            </label>
          </div>
          <div>
            <label>
              <input type="radio" v-model="selectedNotificationOption" value="Email por No Uso" />
              Email por No Uso
            </label>
          </div>
          <ButtonPrime label="Enviar" @click="confirmarNotificacion" />
          <ButtonPrime label="Cancelar" @click="closeEmailModal" class="p-button-secondary" />
        </div>
      </DialogPrime>
  
      <!-- Modal para notificaciones push -->
      <DialogPrime header="Enviar Notificaciones Push" v-model:visible="showPushModal" :modal="true" :closable="false">
        <div>
          <p>¿Está seguro de que desea enviar notificaciones push por no uso a los usuarios seleccionados?</p>
          <ButtonPrime label="Enviar Notificaciones Push" @click="confirmarNotificacionPush" />
          <ButtonPrime label="Cancelar" @click="closePushModal" class="p-button-secondary" />
        </div>
      </DialogPrime>
    </div>
  </template>
  
  <script>
  
  import usuarioService from '@/services/UsuarioService'; // Asegúrate de que el servicio esté disponible
  import notiService from '@/services/NotiService';
  import ColegioDropdown from '@/components/selectores/ColegioDropdown.vue'; // Importa el componente ColegioDropdown
  import SingleCursoCombo from '@/components/selectores/SingleCursoCombo.vue'; // Importa el componente SingleCursoCombo
  import DataTable from 'primevue/datatable'; // Importa el componente DataTable
  import ColumnPrime from 'primevue/column'; // Importa el componente Column
  import DialogPrime from 'primevue/dialog'; // Importa el componente Dialog


  
  export default {
    components: {
      ColegioDropdown, // Registra el componente ColegioDropdown
      SingleCursoCombo, // Registra el componente SingleCursoCombo
      DataTable,
      ColumnPrime,
      DialogPrime
    },
    data() {
      return {
        colegios: [], // Lista de colegios
        cursos: [], // Lista de cursos
        selectedColegio: '',
        selectedCurso: [], // Cambiado a array para permitir múltiples selecciones
        usuarios: [], // Lista de usuarios encontrados
        selectedUsuarios: [], // Lista de IDs de usuarios seleccionados
        errors: {
          cursos: '' // Para manejar errores de selección de cursos
        },
        mostrarErrores: false, // Controla la visualización de errores
        showEmailModal: false, // Controla la visibilidad del modal
        showPushModal: false, // Controla la visibilidad del modal
        selectedNotificationOption: '' // Almacena la opción de notificación seleccionada
      };
    },
    methods: {
      async cargarColegios() {
        // Lógica para cargar colegios desde el servicio
        try {
          const response = await usuarioService.getColegios(); // Asegúrate de que este método exista
          this.colegios = response.data; // Ajusta según la estructura de tu respuesta
        } catch (error) {
          console.error('Error al cargar colegios:', error);
        }
      },
      async cargarCursos() {
        // Lógica para cargar cursos según el colegio seleccionado
        try {
          const response = await usuarioService.getCursosPorColegio(this.selectedColegio); // Asegúrate de que este método exista
          this.cursos = response.data; // Ajusta según la estructura de tu respuesta
        } catch (error) {
          console.error('Error al cargar cursos:', error);
        }
      },
      async buscarUsuarios() {
        // Lógica para buscar usuarios según el curso seleccionado
        if (this.selectedCurso.length === 0) {
          this.errors.cursos = 'Debes seleccionar al menos un curso';
          this.mostrarErrores = true;
          return;
        }
        this.mostrarErrores = false; // Reinicia la visualización de errores
        try {
          const requestBody = {
            IdColegio: this.selectedColegio,
            IdCursos: this.selectedCurso.join(',') // Asegúrate de que selectedCurso sea un array
          };
          const response = await usuarioService.getUsuariosPorCursoOne(requestBody); // Asegúrate de que este método exista
          this.usuarios = response.data; // Ajusta según la estructura de tu respuesta
          this.selectedUsuarios = []; // Reinicia la selección al buscar nuevos usuarios
        } catch (error) {
          console.error('Error al buscar usuarios:', error);
        }
      },
      openEmailModal(user) {
            console.log(user.email)
             this.showEmailModal = true; // Abre el modal
             this.selectedUsuarios.push(user);
      },

      openEmailModalSelect(){
            this.showEmailModal = true; // Abre el modal
      },

      openPushModalSelect(){
        this.showPushModal = true; 
      },

      openPushModal(user) {
        this.selectedUsuarios.push(user);
        this.showPushModal = true; // Abre el modal para notificaciones push
      },
      closeEmailModal() {
        this.showEmailModal = false; // Cierra el modal
        this.selectedNotificationOption = ''; // Reinicia la opción de notificación seleccionada
      },
      closePushModal() {
        this.showPushModal = false; // Cierra el modal de push
      },
      async confirmarNotificacion() {
        // Lógica para notificar por email
        if (this.selectedNotificationOption === 'Estadisticas Alumnos Opción A') {
          for (const user of this.selectedUsuarios) {
            const body = { usuario_id: user.id_usuario, email: user.email }; // Crea el cuerpo de la solicitud
            try {
              const response = await notiService.emailEstadisticasAlumnoOpcionA(body); // Llama al endpoint con el cuerpo correcto
              console.log(`Notificación por email enviada a usuario ID: ${user.id_usuario}`, response.data);
            } catch (error) {
              console.error('Error al enviar notificación por email:', error);
            }
          }
        } else if (this.selectedNotificationOption === 'Email por No Uso') {
          for (const user of this.selectedUsuarios) {
            const body = { email: user.email }; // Crea el cuerpo de la solicitud
            try {
              const response = await notiService.emailNoUsoAlumno(body); // Llama al endpoint para el email por no uso
              console.log(`Notificación por email de No Uso enviada a usuario ID: ${user.id_usuario}`, response.data);
            } catch (error) {
              console.error('Error al enviar notificación por email de No Uso:', error);
            }
          }
        }
        this.closeEmailModal(); // Cierra el modal después de enviar todas las notificaciones
      },
      async confirmarNotificacionPush() {
        for (const user of this.selectedUsuarios) {
          try {
            const response = await notiService.pushNoUsoUsuario(user); // Llama al endpoint para enviar la notificación push
            console.log(`Notificación push enviada a usuario ID: ${user.id_usuario}`, response.data);
          } catch (error) {
            console.error('Error al enviar notificación push:', error);
          }
        }
        this.closePushModal(); // Cierra el modal después de enviar todas las notificaciones push
      },
      async notificarPush(usuario) {
        // Lógica para notificar por push
        console.log(`Notificando por push a ${usuario.user_id}`);

        try {
              const response = await notiService.pushNoUsoUsuario(usuario); // Llama al endpoint para el email por no uso
              console.log(`Notificación por email de No Uso enviada a usuario ID: ${usuario.id_usuario}`, response.data);
            } catch (error) {
              console.error('Error al enviar notificación por email de No Uso:', error);
            }
      }
    },
    mounted() {
      this.cargarColegios(); // Carga los colegios al montar el componente
    }
  };
  </script>
  
  <style scoped>
  .notificar-usuarios-container {
    padding: 1rem;
  }
  
  .notificar-usuarios-card {
    background: var(--surface-card);
    border-radius: var(--border-radius);
    padding: 1rem;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }
  
  .card-title {
    margin: 0;
    font-size: 1.5rem;
    color: var(--text-color);
  }
  </style>